import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const hourlyGraphGet = createAsyncThunk('tenant_dashboard/hourly_graph', async (params) => {
  return await apiInstance.get('/tenant_dashboard/hourly_graph', { params });
});

export const topFiveUserGet = createAsyncThunk('tenant_dashboard/top_five_user', async (params) => {
  return await apiInstance.get('/tenant_dashboard/top_five_user', { params });
});

export const dispositionGet = createAsyncThunk('tenant_dashboard/disposition', async (params) => {
  return await apiInstance.get('/tenant_dashboard/disposition', { params });
});

export const outboundStatusGet = createAsyncThunk(
  'tenant_dashboard/outbound_status',
  async (params) => {
    return await apiInstance.get('/tenant_dashboard/outbound_status', { params });
  }
);

export const inboundStatusGet = createAsyncThunk(
  'tenant_dashboard/inbound_status',
  async (params) => {
    return await apiInstance.get('/tenant_dashboard/inbound_status', { params });
  }
);

export const listStatusGet = createAsyncThunk('tenant_dashboard/list_status', async (params) => {
  return await apiInstance.get('/tenant_dashboard/list_status', { params });
});

export const userStatusGet = createAsyncThunk('tenant_dashboard/user_status', async (params) => {
  return await apiInstance.get('tenant_dashboard/user_status', { params });
});

const initialState = {
  hourlyGraphDetails: [],
  topFiveUserDetails: [],
  dispositionDetails: [],
  outboundStatusDetails: [],
  inboundStatusDetails: [],
  listStatusDetails: [],
  userStatus: {
    total_users: '0',
    idle: '0',
    on_call: '0',
    others: '0'
  }
};

const tenantDashboardSlice = createSlice({
  name: 'tenantDashboard',
  initialState,
  reducers: {
    clearTenantDashboardSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(hourlyGraphGet.fulfilled, (state, action) => {
      state.hourlyGraphDetails = action?.payload;
    });
    builder.addCase(topFiveUserGet.fulfilled, (state, action) => {
      state.topFiveUserDetails = action?.payload;
    });
    builder.addCase(dispositionGet.fulfilled, (state, action) => {
      state.dispositionDetails = action?.payload;
    });
    builder.addCase(outboundStatusGet.fulfilled, (state, action) => {
      state.outboundStatusDetails = action?.payload;
    });
    builder.addCase(inboundStatusGet.fulfilled, (state, action) => {
      state.inboundStatusDetails = action?.payload;
    });
    builder.addCase(listStatusGet.fulfilled, (state, action) => {
      state.listStatusDetails = action?.payload;
    });
    builder.addCase(userStatusGet.fulfilled, (state, action) => {
      state.userStatus = action?.payload?.[0];
    });
  }
});

export default tenantDashboardSlice.reducer;
export const { clearTenantDashboardSlice } = tenantDashboardSlice.actions;

export const selectHourlyGraphDetails = (state) => state.tenantDashboard.hourlyGraphDetails;
export const useHourlyGraphDetails = () => {
  const hourlyGraphDetails = useSelector(selectHourlyGraphDetails);
  return useMemo(() => hourlyGraphDetails, [hourlyGraphDetails]);
};

export const selectTopFiveUserDetails = (state) => state.tenantDashboard.topFiveUserDetails;
export const useTopFiveUserDetails = () => {
  const topFiveUserDetails = useSelector(selectTopFiveUserDetails);
  return useMemo(() => topFiveUserDetails, [topFiveUserDetails]);
};

export const selectDispositionDetails = (state) => state.tenantDashboard.dispositionDetails;
export const useDispositionDetails = () => {
  const dispositionDetails = useSelector(selectDispositionDetails);
  return useMemo(() => dispositionDetails, [dispositionDetails]);
};

export const selectOutboundStatusDetails = (state) => state.tenantDashboard.outboundStatusDetails;
export const useOutboundStatusDetails = () => {
  const outboundStatusDetails = useSelector(selectOutboundStatusDetails);
  return useMemo(() => outboundStatusDetails, [outboundStatusDetails]);
};

export const selectInboundStatusDetails = (state) => state.tenantDashboard.inboundStatusDetails;
export const useInboundStatusDetails = () => {
  const inboundStatusDetails = useSelector(selectInboundStatusDetails);
  return useMemo(() => inboundStatusDetails, [inboundStatusDetails]);
};

export const selectListStatusDetails = (state) => state.tenantDashboard.listStatusDetails;
export const useListStatusDetails = () => {
  const listStatusDetails = useSelector(selectListStatusDetails);
  return useMemo(() => listStatusDetails, [listStatusDetails]);
};

export const selectUserStatus = (state) => state.tenantDashboard.userStatus;
export const useUerStatus = () => {
  const userStatus = useSelector(selectUserStatus);
  return useMemo(() => userStatus, [userStatus]);
};
